export const BECAS = [
  {
    label: "INDIVIDUAL",
    name: "INDIVIDUAL",
    value: "INDIVIDUAL",
    price: 2500,
    id: 1
  },
  {
    label: "HERMANOS",
    name: "HERMANOS",
    value: "HERMANOS",
    price: 2000,
    id: 2
  },
  {
    label: "PRIMOS",
    name: "PRIMOS",
    value: "PRIMOS",
    price: 2200,
    id: 3
  },
  {
    label: "BECA ANUAL",
    name: "BECA ANUAL",
    value: "BECA_ANUAL",
    price: 1500,
    id: 4
  },
  {
    label: "TRANSFERENCIA",
    name: "TRANSFERENCIA",
    value: "TRANSFERENCIA",
    price: 2500,
    id: 5
  },
]